module.exports = __webpack_public_path__ + "static/media/spinner-blue.38153435.svg";